export const saveToLocalStorage = (item, value) => {
    localStorage.setItem(item, JSON.stringify(value));
};

export const getFromLocalStorage = (item) => {
    const storedValue = localStorage.getItem(item);
    try {
        return storedValue ? JSON.parse(storedValue) : null;
    } catch (error) {
        return storedValue;
    }
};

export const uuidv4 = () => {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(
        /[xy]/g,
        function (c) {
            var r = (Math.random() * 16) | 0,
                v = c == 'x' ? r : (r & 0x3) | 0x8;
            return v.toString(16);
        }
    );
};
